function AdminLoadingState() {
  return (
    <div className="mx-auto w-[min(960px,calc(100%-40px))] py-10" role="status">
      <div className="rounded-[24px] border border-[#1832281f] bg-[rgba(249,245,238,0.9)] p-6 text-[#183228] shadow-[0_12px_28px_rgba(24,50,40,0.08)]">
        <p className="m-0 text-base font-semibold">Laster admin...</p>
        <p className="mt-2 text-sm text-[#355046]">
          Hvis denne visningen blir staende mer enn noen sekunder, oppdater siden med <strong>Ctrl+Shift+R</strong>
          for aa hente nyeste versjon.
        </p>
      </div>
    </div>
  );
}

export default AdminLoadingState;